import { CollapseIcon, getIsMobile } from "@farzoom/common-ui-components";
import classnames from "classnames";
import { createUseStyles } from "react-jss";

type CollapseIconWrapperProps = {
  collapse: boolean;
  collapsed: boolean;
};

const useStyles = createUseStyles({
  icon: {
    width: 24,
    height: 24,
    marginLeft: 8,
    transform: "rotateZ(-180deg)",
    transition: ["transform", "300ms", "ease"],
    "&.collapsed": {
      transform: "rotateZ(0)",
    },
  },
});

export const CollapseIconWrapper = ({ collapse, collapsed }: CollapseIconWrapperProps) => {
  const classes = useStyles();
  const isMobile = getIsMobile();
  return collapse ? (
    <div className={classnames(classes.icon, { collapsed })}>
      <CollapseIcon />
    </div>
  ) : null;
};
